import React from 'react';
import HomeConnectItem from './ConnectItem';
import "./connect.scss";
import { AiFillFacebook, AiOutlineTwitter, AiOutlineGoogle, AiFillInstagram } from "react-icons/ai";
import { FaPinterestP } from "react-icons/fa";

const Connect = () => {
    
        
        
    
}

export default Connect;